import { render, staticRenderFns } from "./RegistrationFormUser.vue?vue&type=template&id=00b2a3ac&scoped=true&"
import script from "./RegistrationFormUser.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2a3ac",
  null
  
)

export default component.exports